import React from "react";
import DetailPresenter from "./DetailPresenter";

import { Navigate, useParams } from "react-router-dom";
import { useQuery, gql } from "@apollo/client";
import RouteChangeTracker from "../../components/RouteChangeTracker"

const GET_DETAIL = gql`
  query getFontList($familyId: Int!) {
    fontDetail(familyId: $familyId) {
      idx
      familyname
      familyname_eng
      webfontname
      format
      concept
    }
    detailFontList(familyId: $familyId) {
      webfontname
      family_idx
      filename
      eng
      kor
      korean_char_num
      hanja
    }
    fontStory(familyId: $familyId) {
      family
      types
      count
    }
    relatedFontList(familyId: $familyId) {
      idx
      webfontname
      familyname
      familyname_eng
      types
      file
      is_new
      file_names
      format
      fonts
      family_type
    }
  }
`;

// const SET_LOG = gql`
//   mutation AddLog($id: Int!) {
//     addLog(id: $id) {
//       result
//     }
//   }
// `;




const Detail = () => {

  let { id } = useParams();



  window.scrollTo(0, 0);

  // if (isNaN(parseInt(id))) {
  //   return <Navigate to="/" />;
  // }

  const { loading, data } = useQuery(GET_DETAIL, {
    variables: { familyId: parseInt(id) },
  });

  if (data?.fontDetail === null || data?.detailFontList.length === 0) {
    return <Navigate to="/" />;
  }



  //google analytice route tracking
  RouteChangeTracker()

  return (
    <DetailPresenter
      loading={loading}
      detail={data?.fontDetail}
      info={data?.detailFontList}
      story={data?.fontStory}
      related={data?.relatedFontList}
    />
  );


}



export default Detail;


// export default () => {
//   let { id } = useParams();



//   window.scrollTo(0, 0);

//   // if (isNaN(parseInt(id))) {
//   //   return <Navigate to="/" />;
//   // }

//   const { loading, data } = useQuery(GET_DETAIL, {
//     variables: { familyId: parseInt(id) },
//   });

//   if (data?.fontDetail === null || data?.detailFontList.length === 0) {
//     return <Navigate to="/" />;
//   }

//   // const result = useMutation(SET_LOG, {
//   //   variables: { id: parseInt(id) },
//   // });

//   // console.log("@result");
//   // console.log(result);



//   //google analytice route tracking
//   RouteChangeTracker()

//   return (
//     <DetailPresenter
//       loading={loading}
//       detail={data?.fontDetail}
//       info={data?.detailFontList}
//       story={data?.fontStory}
//       related={data?.relatedFontList}
//     />
//   );
// };
